import React, { ReactElement, FunctionComponent, memo } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import duration from 'dayjs/plugin/duration'
import times from 'lodash/times'
import Grid from '@sport1/react-elements/Grid'
import CaptionFont from '../../Theme/Fonts/Caption'
import { BROADCAST_WIDTH_MULTIPLICATOR } from '..'

type TimeRowType = {
    startTime: Dayjs
    endTime: Dayjs
}

const TimeRow: FunctionComponent<TimeRowType> = ({ startTime, endTime }): ReactElement => {
    dayjs.extend(duration)
    const hours: number = Math.floor(dayjs.duration(endTime.diff(startTime)).asHours())
    return (
        <Grid noExpand horizontal overflow="hidden">
            {times(hours, (hour: number): ReactElement => {
                return (
                    <Grid
                        key={`timerow-hour-${hour}`}
                        noExpand
                        minWidth={60 * BROADCAST_WIDTH_MULTIPLICATOR}
                        height={33}
                        centerVertical
                        backgroundColor="pearl"
                    >
                        <CaptionFont color="keshi-3" numberOfLines={1}>
                            {dayjs(startTime).add(hour, 'hour').format('HH:mm')}
                        </CaptionFont>
                    </Grid>
                )
            })}
        </Grid>
    )
}

export default memo(TimeRow)
